import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { helpers } from "../../../../common/lib";

export default (auditImage: number) => {
    const { auditLocations, locations, typesList } = useSelector(
        (state) => state
    );

    return useMemo(() => {
        if (auditImage) {
            /** Get shackleton from the typesList  */
            const shackleton = typesList.services.data.find(
                (item) => item.name === "Shackleton"
            );

            /** Check for the image distance if it is present
             * If there are no serviceRessult return null
             * Check if shackleton is present
             */

            const imageDistance = auditImage.services
                ? auditImage.services.find(
                      (item) =>
                          shackleton &&
                          item.auditImageId === auditImage.id &&
                          shackleton.id === item.service
                  )
                : null;

            let closest = Number.MAX_VALUE;
            let next = {};
            for (let a of auditLocations.data) {
                const location = helpers.getListItemForId(
                    locations,
                    a.location
                );
                if (
                    location?.geo &&
                    auditImage?.latitude &&
                    auditImage?.longitude
                ) {
                    /** Caluclate distance if there is no distance from backend */
                    const distance = imageDistance
                        ? parseFloat(imageDistance.serviceResultValue)
                        : helpers.distance.inKmBetweenEarthCoordinates(
                              auditImage.latitude,
                              auditImage.longitude,
                              location.geo[0].latitude,
                              location.geo[0].longitude
                          );

                    if (distance < closest) {
                        closest = distance;
                        next = location;
                        next.distance = distance;
                    }
                }
            }
            return next;
        }
    }, [auditImage, auditLocations.data, locations, typesList.services.data]);
};
